import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiAppFooterComponent } from './footer.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiAppFooterComponent,
    ],
    exports: [
        EuiAppFooterComponent,
    ],
})
export class EuiAppFooterModule { }
